import { useAuth } from '@/lib/auth/auth';
import { organizationKeys } from '@/features/workspaces/useOrganization';
import { organizationInvitationKeys } from '@/features/workspaces/useOrganizationInvitations';
import { organizationMemberKeys } from '@/features/workspaces/useOrganizationMembers';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type RevokeOrganizationInvitationInput = {
  organizationID: string;
  invitationID: string;
};

export function useRevokeOrganizationInvitation() {
  const request = useAuth((state) => state.request);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ organizationID, invitationID }: RevokeOrganizationInvitationInput) =>
      request<void>(`/organizations/${organizationID}/invitations/${invitationID}`, {
        method: 'DELETE',
      }),
    onSuccess: async (_result, variables) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: organizationInvitationKeys.list(variables.organizationID),
        }),
        queryClient.invalidateQueries({
          queryKey: organizationMemberKeys.list(variables.organizationID),
        }),
        queryClient.invalidateQueries({
          queryKey: organizationKeys.detail(variables.organizationID),
        }),
      ]);
    },
  });
}
